/* TODO: t() */
import React, { Component } from 'react';
import { View } from 'react-native';

import { Text, Link } from '../uiold';

import InvoiceConnect from './InvoiceConnect';
import { revokeAuth } from './quickbooks/helpers';

import { Account } from '../../types/shared/Account';

type Props = {
  account: Account;
};

type State = {
  isCreatingMetadata: boolean;
};

class QuickbooksSettings extends Component<Props, State> {
  state: State = {
    isCreatingMetadata: false,
  };

  render() {
    let { account } = this.props;

    return (
      <InvoiceConnect account={account} invoiceProvider="quickbooks">
        <View>
          <Text>
            Your Quickbooks account is connected.{' '}
            <Link onPress={revokeAuth}>Click here to disconnect</Link>.
          </Text>
          <Text>
            When connecting to Quickbooks, MarketWurks will create three items
            called “Signup/Membership Fee”, “Market Charges” and “Tax”{' '}
            <Link href="https://qbo.intuit.com/app/items">at this page</Link>.
            These items are required for creating new invoices.
          </Text>
        </View>
      </InvoiceConnect>
    );
  }
}

export default QuickbooksSettings;
